import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';

export default function ConversionFieldChoiceVwpfs(props) {
    const { colClassName, formGroupClassName = '', customControlClassName = '', field, inputType, path, id, updateChoice, ariaLabel } = props;
    const { type, label, choices, required, disabled, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const titleFor = (choice) => {
        if (name === 'duration') {
            return choice.key;
        }
        if (name === 'yearly_km') {
            return Number(choice.key).toLocaleString('nl-NL');
        }
        return choice.label;
    };

    // At most five tiles per row, spread evenly over the rows (6 → 3 + 3, 7 → 4 + 3). The longest title tells
    // the stylesheet when fewer fit (_flow-vwpfs-choices.scss).
    const choiceCount = choices?.length || 1;
    const choiceColumns = Math.ceil(choiceCount / Math.ceil(choiceCount / 5));
    const longestTitle = Math.max(0, ...(choices ?? []).map((choice) => String(titleFor(choice)).replace(/<[^>]*>/g, '').length));

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name} ${formGroupClassName}`}>
                <div className="row gutters-2 align-items-lg-center">
                    {label && (
                        <div className="col-12 col-lg-5">
                            <Form.Label id={`${id}-label`} dangerouslySetInnerHTML={{ __html: label }} />
                        </div>
                    )}
                    {/* Without a label (the finance calculator renders its own), the choices take the full width. */}
                    <div className={label ? 'col-12 col-lg-7' : 'col-12'}>
                        <div
                            className="flow--vwpfs-choices"
                            role={inputType === 'radio' ? 'radiogroup' : 'group'}
                            aria-labelledby={label ? `${id}-label` : undefined}
                            aria-label={label ? undefined : ariaLabel}
                            style={{ '--choice-columns': String(choiceColumns), '--choice-title-width': `${longestTitle}ch` }}
                        >
                            {choices?.map((choice, choiceIndex) => {
                                const title = titleFor(choice);

                                return (
                                    <div key={choice.key} className={`flow--vwpfs-choice`}>
                                        <Form.Check
                                            className={`custom-control custom-${inputType} ${customControlClassName} ${error ? 'is-error' : ''}`}
                                            type={inputType}
                                            id={`${id}.choices.${choiceIndex}-${choice.key}`}
                                        >
                                            <Form.Check.Input
                                                type={inputType}
                                                className="custom-control-input"
                                                name={id}
                                                value={choice.key}
                                                {...{
                                                    required,
                                                    disabled,
                                                }}
                                                checked={value?.includes(choice.key)}
                                                onChange={(e) => {
                                                    updateChoice(choice, e.target.checked, () => {
                                                        trigger(path);
                                                    });
                                                }}
                                            />
                                            <Form.Check.Label className="custom-control-label">
                                                <span className="custom-control-label__title" dangerouslySetInnerHTML={{ __html: title }} />
                                                {choice?.['pay-off'] && (
                                                    <span className="custom-control-label__pay-off">{choice?.['pay-off']}</span>
                                                )}
                                                {choice?.sublabel && (
                                                    <span className="custom-control-label__subtitle" dangerouslySetInnerHTML={{ __html: choice.sublabel }} />
                                                )}
                                            </Form.Check.Label>
                                        </Form.Check>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    {error && (
                        <Form.Control.Feedback type="invalid">
                            {error}
                        </Form.Control.Feedback>
                    )}
                </div>
            </Form.Group>
        </div>
    );
}
